/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Change_PlanInputs */

const et_contact_change_plan = /** @type {(inputs: Contact_Change_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Vali teine pakett`)
};

const en_contact_change_plan = /** @type {(inputs: Contact_Change_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Choose another plan`)
};

/**
* | output |
* | --- |
* | "← Choose another plan" |
*
* @param {Contact_Change_PlanInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_change_plan = /** @type {((inputs?: Contact_Change_PlanInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Change_PlanInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_change_plan(inputs)
	return en_contact_change_plan(inputs)
});